import React, { Fragment } from 'react'

import GovActionContainer from './container'
import GovActionWrapper from './views/wrapper'
import GovActionToggle from './views/toggle'
import GovActionComplete from './views/complete'

const hasOptions = (options = []) => options.filter(option => option).length > 0

// eslint-disable-next-line react/display-name
const recordActionsToDisplay = ({ actionsForRecord, defaultState }) => ({ record, children }) => {
  const options = actionsForRecord({ record })

  return hasOptions(options) ? (
    <GovActionContainer
      defaultState={defaultState}
      options={options}
      render={({
        open,
        toggle,
        defaultOption,
        onChange,
        options,
        actionForm,
        currentOption,
        handleSuccess,
        isCompleted,
        completedMessage,
        onComplete,
        resetForm,
      }) => (
          <Fragment>
            <div className="recordDisplayList--heading--title--wrapper">
              {children}
              <GovActionToggle
                open={open}
                toggle={
                  isCompleted
                    ? defaultOption.onComplete || currentOption.onComplete
                      ? () => {
                        resetForm()
                        const onCompleteToUse = defaultOption.onComplete
                          ? defaultOption.onComplete
                          : currentOption.onComplete

                        onCompleteToUse()
                      }
                      : onComplete
                    : toggle
                }
                options={options}
                onChange={onChange}
                icon={defaultOption.icon}
                label={defaultOption.label || 'Actions'}
                formSuccess={isCompleted}
              />
            </div>

            {isCompleted ? (
              <GovActionComplete
                onClick={
                  defaultOption.onComplete || currentOption.onComplete
                    ? () => {
                      resetForm()
                      const onCompleteToUse = defaultOption.onComplete
                        ? defaultOption.onComplete
                        : currentOption.onComplete

                      onCompleteToUse()
                    }
                    : onComplete
                }>
                {completedMessage}
              </GovActionComplete>
            ) : (
                <GovActionWrapper open={open}>
                  {actionForm
                    ? React.createElement(actionForm, {
                      currentOption,
                      onChange,
                      handleSuccess,
                      resetForm,
                    })
                    : null}
                </GovActionWrapper>
              )}
          </Fragment>
        )}>
      {children}
    </GovActionContainer>
  ) : (
      children
    )
}

export default recordActionsToDisplay



// WEBPACK FOOTER //
// ./src/ui/gov-actions/record-actions-to-display.jsx